import {
  DELETE_CHAT_MESSAGES_SUCCESS,
  GET_CHAT_USERS_SUCCESS,
  GET_COMMENT_BOARD_LIST_SUCCESS,
  GET_COMMENT_BOARD_SUCCESS,
  INIT_CHAT_SESSION_SUCCESS,
  LOAD_CHAT_MESSAGES_SUCCESS,
  NEW_MESSAGE,
  RESET_COMMENT_BOARD,
  RESET_COMMENT_BOARD_LIST,
  SAVE_DIALOG,
  SAVE_MESSAGES,
  SAVE_SESSION,
  SEND_MESSAGE_WITH_MEDIA,
  SEND_MESSAGE_WITH_MEDIA_FAILED,
  SEND_MESSAGE_WITH_MEDIA_SUCCESS,
  SET_SESSION_STATUS,
  UPDATE_COMMENT_BOARD_LAYOUT_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  commentBoard: null,
  chatUsers: [],
  commentBoardMessages: null,
  QBSession: null,
  QBDialog: null,
  QBChatLoaded: false,
  sessionIsActive: false,
  commentBoardList: null,
  isSendingMessage: false,
}

const CommentBoard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COMMENT_BOARD_SUCCESS:
    case UPDATE_COMMENT_BOARD_LAYOUT_SUCCESS:
      return {
        ...state,
        commentBoard: action.payload,
      }
    case RESET_COMMENT_BOARD:
      return {
        ...state,
        commentBoard: null,
        chatUsers: [],
        commentBoardMessages: null,
        QBSession: null,
        QBDialog: null,
        QBChatLoaded: false,
      }
    case GET_CHAT_USERS_SUCCESS:
      return {
        ...state,
        chatUsers: action.payload,
      }
    case SAVE_MESSAGES:
      return {
        ...state,
        commentBoardMessages: action.payload
          ? {
              ...state.commentBoardMessages,
              items: action.payload?.items?.reverse(),
              showLoadMore: action.payload?.limit <= action.payload?.items?.length
            }
          : action.payload,
      }
    case SAVE_SESSION:
      return {
        ...state,
        QBSession: action.payload,
      }
    case SAVE_DIALOG:
      return {
        ...state,
        QBDialog: action.payload,
      }
    case NEW_MESSAGE:
      if (
        state.commentBoardMessages?.items
          ?.map(messages => messages._id)
          .includes(action.payload._id)
      ) {
        return state
      } else {
        return {
          ...state,
          commentBoardMessages: {
            ...state.commentBoardMessages,
            items: [...state.commentBoardMessages?.items, action.payload],
          },
        }
      }
    case LOAD_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        commentBoardMessages: {
          ...state.commentBoardMessages,
          items: [...action.payload.items.reverse(), ...state.commentBoardMessages.items],
          showLoadMore: action.payload?.limit <= action.payload?.items?.length
        },
      }
    case INIT_CHAT_SESSION_SUCCESS:
      return {
        ...state,
        QBChatLoaded: true,
        sessionIsActive: true,
      }
    case DELETE_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        commentBoardMessages: {
          ...state.commentBoardMessages,
          items: state.commentBoardMessages.items.filter(
            msg => !action.payload.includes(msg._id)
          ),
        },
      }
    case SET_SESSION_STATUS:
      return {
        ...state,
        sessionIsActive: action.payload,
      }
    case GET_COMMENT_BOARD_LIST_SUCCESS:
      return {
        ...state,
        commentBoardList: action.payload,
      }
    case RESET_COMMENT_BOARD_LIST:
      return {
        ...state,
        commentBoardList: null,
      }
    case SEND_MESSAGE_WITH_MEDIA:
      return {
        ...state,
        isSendingMessage: true,
      }
    case SEND_MESSAGE_WITH_MEDIA_FAILED:
    case SEND_MESSAGE_WITH_MEDIA_SUCCESS:
      return {
        ...state,
        isSendingMessage: false,
      }
    default:
      return state
  }
}

export default CommentBoard
